module.exports = __webpack_public_path__ + "static/img/OM2.5250834c.png";